// import React from 'react';
// import * as Icons from 'react-icons/fa';
// // import footerConfig from '../../config/FooterConfig.json';
// import footerConfig from '../../../config/FooterConfig.json'
// import { Link } from 'react-router-dom';
// import { useTranslatableData } from '../../../Shared/useTranslatableData';
// // import { useTranslatableData } from '../../Shared/LanguageTranslator/useTranslatableData';
// import './Footer.scss'

// const FooterComponent = ({ config = footerConfig }) => {
//   const {
//     translatedData: footerData,
//     // currentLang,
//     // setCurrentLang,
//   } = useTranslatableData({
//     dataMap: config,
//   });

//   return (
//     <footer className="footer">
//       <div className="footer-container">
//         <div className="footer-contact">
//           <h6 className="contact">{footerData?.contactText}</h6>
//           <div className="social-icons">
//             {config?.socialLinks?.map((item, idx) => {
//               const Icon = Icons[item?.icon];
//               return (
//                 <a
//                   className="socialmediaicons"
//                   href={item?.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   key={idx}
//                 >
//                   <Icon />
//                 </a>
//               );
//             })}
//           </div>
//         </div>

//         <div className="footer-sections-row">
//           {footerData?.sections?.map((section, index) => (
//             <div className="footer-section" key={index}>
//               <h2 className="headings">{section.title}</h2>
//               {section?.items?.map((item, i) => {
//                 const isInternalLink = item.url.startsWith('/');
//                 return (
//                   <h6 key={i}>
//                     {isInternalLink ? (
//                       <Link to={item.url} className="footer-link">
//                         {item.title}
//                       </Link>
//                     ) : (
//                       <a
//                         className="footer-link"
//                         href={item?.url}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {item?.title}
//                       </a>
//                     )}
//                   </h6>
//                 );
//               })}
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <h6>{footerData?.copyright}</h6>
//       </div>
//     </footer>
//   );
// };

// export default FooterComponent;

import "./Footer.scss";
import * as Icons from "react-icons/fa";
// import footerConfig from "../../config/FooterConfig.json";
import { Link } from "react-router-dom";
// import { useTranslatableData } from '../../Shared/LanguageTranslator/useTranslatableData';
import { useTranslatableData } from "../../../Shared/useTranslatableData";

import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
const FooterComponent = () => {
  const {
    translatedData: footerData,
    // currentLang,
    // setCurrentLang,
  } = useTranslatableData({
    // dataMap: config,
    dataMap: "",
  });
  const lang_ar = sessionStorage.getItem("language") === "ar";
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            {/* <h2>
              `${lang_ar}?"هل تحتاج إلى المساعدة؟ تحدث مع خبيرنا":Need help?
              Talk to our expert`
            </h2> */}
            <h2>
              {lang_ar
                ? "هل تحتاج إلى المساعدة؟ تحدث مع خبيرنا"
                : "Need help? Talk to our expert"}
            </h2>
            <p>
              {lang_ar
                ? "تحدث مع خبيرنا واحصل على عرض سعر حصري مخصص لك، وقارن بين العروض المختلفة واختر العرض الأنسب لك."
                : "Talk to our expert and get exclusive quotation for you, compare and choose your best offer"}
            </p>
          </div>

          <div className="footer-right">
            <a href="tel:+96824762600" className="contact-btn phone">
              <FaPhoneAlt className="icon" />
              +968 24762600
            </a>

            <a href="mailto:branches@rmsme.com" className="contact-btn email">
              <FaEnvelope className="icon" />
              branches@rmsme.om
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
